import { useBranding } from './portalBrandingState';
import { resolveAuthPresentation } from './brandingPresentation';
import BrandLogoImage from './BrandLogoImage';

// Shared brand header for the secondary auth pages (forgot password, reset
// password, verify email).
//
// A branded portal with a safely loaded custom logo shows the Operator's own
// mark; every other state renders the bundled AlgoSys platform logo, labelled
// as such. A branded portal's identity is stated as separate text underneath,
// never implied by the AlgoSys mark. A failed image load falls back to the
// bundled asset instead of leaving a broken placeholder.
export default function AuthBrandLogo({ className = 'h-40 mx-auto object-contain' }) {
  const presentation = resolveAuthPresentation(useBranding());

  return (
    <>
      <BrandLogoImage logoSrc={presentation.logoSrc} alt={presentation.logoAlt} className={className} />
      {presentation.showBusinessNameBadge && (
        <p
          className="mt-2 truncate text-base font-semibold text-brand"
          title={presentation.businessName ?? undefined}
        >
          {presentation.businessName}
        </p>
      )}
    </>
  );
}
